import type { Cliente } from '../db/tipos'
import type { ResolucaoDoAlvo } from './alvoDoEnvio'

// Troca por espaço, e nao remove liso: "24/7" virando "247" mudaria o
// sentido do texto. Colapsa os espacos que sobram (inclusive o do proprio
// caractere trocado) e tira as pontas.
function nomeSeguroParaArquivo(texto: string): string {
  return texto.replace(/[/\\:*?"<>|]/g, ' ').replace(/\s+/g, ' ').trim()
}

// Pedido dela, 05/09/2026: nome do cliente em vez do numero, "facilita a
// visualizacao" na lista de arquivos do celular. O numero do pedido continua
// junto (cliente recorrente sobrescreveria o PDF de um pedido anterior sem
// ele) e o nome da marca entra so no documento por fabrica (um pedido com
// mais de uma fabrica geraria dois arquivos de mesmo nome sem isso).
export function nomeArquivoPdf(
  cliente: Cliente,
  pedidoNumero: string,
  resolucao: ResolucaoDoAlvo,
): string {
  const nomeCliente = nomeSeguroParaArquivo(cliente.nome_fantasia ?? cliente.razao_social)
  const base = `${nomeCliente} - pedido ${pedidoNumero}`
  if (resolucao.tipo === 'consolidado') return `${base}.pdf`
  const nomeMarca = nomeSeguroParaArquivo(resolucao.marca.representada.nome)
  return `${base} - ${nomeMarca}.pdf`
}
